import { render, staticRenderFns } from "./applet-href.vue?vue&type=template&id=3e01a7ef&scoped=true"
import script from "./applet-href.vue?vue&type=script&lang=js"
export * from "./applet-href.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e01a7ef",
  null
  
)

export default component.exports